import styles from "./StructuralReport.module.scss";
import colors from "../../../assets/scss/variable/color.scss";
import React, {useState, useEffect} from "react";
import {default as _} from "../../../helpers/Translate"
import ComboBox from '../../../shared/component/ComboBox/ComboBox2';
import {connect} from "react-redux";
import {useDispatch} from 'react-redux';
import snippets from "../../../helpers/snippets";
import Header from "../../Panel/Header/header";
import Footer from "../../Panel/Footer/footer";
import TextBox from "../../../shared/component/textbox/Textbox";
import RadioButton from "../../../shared/component/RadioButton2/RadioButton";
import CheckBox from "../../../shared/component/CheckBox/CheckBox";
import T from "../../../shared/component/t/T";
import CreatableSelect from 'react-select/creatable';
import Divider from "../../../shared/component/Divider/Divider";
import Popover from "../../../shared/component/Popover/Popover";
import BaseApi from "../../../core/api/BaseApi";
import Button from "../../../shared/component/button/Button";


const baseApi = new BaseApi()

function StructuralReport(props) {
    const dispatch = useDispatch();
    const [language] = useState(props.language)
    const [direction] = useState(props.direction)
    const [form, setForm] = useState([])
    const [data, setData] = useState()
    let chooseOne = {id: -1, text: "choose_one", label: "choose_one", value: "-1"}

    const [lang, setLang] = useState({
        options: [chooseOne,
            {id: 0, text: "FA", value: "0"},
            {id: 1, text: "EN", value: "1"}],
        selected: "-1",
        handler: (e) => combinedHandler(setLang, 'selected', e),
        title: "choose_report_language",
        className: "langSelector",
        show: false
    })

    const [groups, setGroups] = useState({
        options: [],
        selected: "-1",
        handler: (e) => combinedHandler(setGroups, 'selected', e),
        title: "choose_report_group",
        className: "groupSelector",
        show: true
    })

    const [structures, setStructures] = useState({
        options: [],
        selected: "-1",
        handler: (e) => combinedHandler(setStructures, 'selected', e),
        title: "choose_report_structures",
        className: "structuresSelector",
        show: true
    })


    const [details, setDetails] = useState({show: false})

    const [resForm, setResForm] = useState({})
    const [resSection, setResSection] = useState([])

    useEffect(() => {
        baseApi.fullFetch("structural_report", "get").then((response) => { //, {data:{'group_id': 1}}
            let gps = response.data?.groups
            setData(gps)
        })
    }, [])

    useEffect(() => {
        if (data) {
            let opt = [chooseOne,
                ...data?.map(item => {
                    return {
                        id: item.id,
                        text: `${item.title} - ${item.modalities} - ${item.body_part}`,
                        value: String(item.id)
                    }
                })]
            combinedHandler(setGroups, 'options', opt)
        }
    }, [data])

    useEffect(() => {
        let items = data?.filter(item => item.id?.toString() === String(groups.selected))?.pop()?.structures
        // console.log("groups", groups, items)
        if (items) {
            let opt = [chooseOne,
                ...items?.map(str => {
                    return {id: str.id, text: `${str.title}`, value: String(str.id)}
                })]
            combinedHandler(setStructures, 'options', opt)
        } else {
            setStructures(prevState => ({
                ...prevState,
                options: [chooseOne],
                selected: '-1'
            }));
        }
    }, [groups])

    useEffect(() => {
        if (structures.selected !== "-1") {
            let gr = data?.filter(gr => gr.id.toString() === groups.selected)
            let str = gr?.[0].structures?.filter(st => st.id?.toString() === structures.selected)
            if (str.length < 1) console.error("why there is not  any question for this ID!!")
            if (str.length > 1) console.error("how can find two items with same ID!!")
            setForm(str?.[0])
        } else {
            setForm([])
        }
    }, [structures.selected])

    useEffect(() => {
        // console.log(form)
        initForm()
    }, [form]);

    useEffect(() => {
        console.log("resForm", resForm)
    }, [resForm]);


    const combinedHandler = (setState, key, value) => {
        setState(prevState => ({...prevState, [key]: value}));
    }

    const initForm = () => {
        let reformed = {}
        let sec = new Set()
        form?.details?.map(item => {
            let obj
            if (item["data_type"] === "select") {
                let vals = []
                item['options']?.map((items, index) => {
                    vals = [...vals, {id: items.id, text: items.text, label: items.text, value: items.value}];
                })

                obj = {
                    [`${item.id}`]: {
                        ...item,
                        visibility: checkInitialDependencies(item),
                        values: [...vals]
                    }
                }
            } else if (item["data_type"] === "checkbox") {
                let vals = []
                item['options']?.map((items, index) => {
                    vals = [...vals, items.text];
                })

                obj = {
                    [`${item.id}`]: {
                        ...item,
                        ans: [],
                        visibility: checkInitialDependencies(item),
                        values: [...vals]
                    }
                }
            } else if (item["data_type"] === "radiobutton") {
                let vals = item["options"]?.map((item, index) => {
                    return {value: item.id, text: item.text, id: item.id}
                })

                obj = {
                    [`${item.id}`]: {
                        ...item,
                        visibility: checkInitialDependencies(item),
                        values: [...vals]
                    }
                }
            } else if (item["data_type"] === "textarea" || item["data_type"] === "input") {
                obj = {
                    [`${item.id}`]: {
                        ...item,
                        visibility: checkInitialDependencies(item),
                    }
                }
            }
            reformed = {...reformed, ...obj}
            sec.add(item['section'])
        })
        setResForm(reformed)
        setResSection(Array.from(sec))
    }

    const checkItemDependency = (id, ans = 0) => {
        let active = findAnsWithDepth(id, ans)
        let deactivate = findDepsWithDepth(id, resForm[id]?.ans)?.filter(item => !active?.includes(item))
        return changeVisibility(active, deactivate)
    }

    const checkItemDependencyCurrent = (id, ans) => {
        return findDep(makeId_ValueString(id, ans))
    }

    const findDep = (str) => {
        return Object.entries(resForm).filter(([, value]) => value.dependencies?.includes(str)).map(i => {
            return parseInt(i)
        })
    }

    const findDep2 = (id) => {
        return Object.entries(resForm).filter(([, value]) => value.dependencies?.some((value) => value.startsWith(makeId_ValueString(id, ""))))
            .map(i => {
                return parseInt(i)
            })
    }

    const findDepsWithDepth = (id, value) => {
        let lst = findDep(makeId_ValueString(id, value))
        for (let i = 0; i < lst.length; i++) {
            let lst2 = findDep2(lst[i])
            if (!snippets.isObjectEmpty(lst2)) {
                lst2.map(item => {
                    lst.push(item)
                })
            }
        }
        return Array.from(new Set(lst))
    }

    const findAnsWithDepth = (id, value) => {
        let lst = checkItemDependencyCurrent(id, value)
        for (let i = 0; i < lst.length; i++) {
            let lst2 = findDep(makeId_ValueString(lst[i], resForm[lst[i]]?.ans))
            if (!snippets.isObjectEmpty(lst2)) {
                lst2.map(item => {
                    lst.push(item)
                })
            }
        }
        return Array.from(new Set(lst))
    }

    const checkInitialDependencies = (item) => {
        return snippets.isObjectEmpty(item.dependencies);
    }

    const changeVisibility = (active, deactivate) => {
        console.log("changeVisibility", active, deactivate)
        let someProperty = {...resForm}
        active.map(item => someProperty[item] = {...someProperty[item], visibility: true})
        deactivate.map(item => someProperty[item] = {...someProperty[item], visibility: false})
        return someProperty
    }


    const makeId_ValueString = (id, value) => {
        return `${id}-${value}`
    }

    const handleStructuralCombo2 = (id, event) => {
        let value = event === null ? "" : event.value
        let someProperty = checkItemDependency(id, value)
        //here user can make a new option
        if (event?.__isNew__) {
            someProperty[id] = {...someProperty[id], options: [...someProperty[id].options, event]};
        }
        someProperty[id] = {...someProperty[id], ans: value};
        setResForm(someProperty)
    }

    const handleStructuralCheck = (id, index, value) => {
        let someProperty = {...resForm}
        let ans = [...someProperty[id]?.ans]
        if (value) {
            ans.push(index.toString())
            someProperty = changeVisibility(findAnsWithDepth(id, index), [])
        } else if (value === false) {
            ans = ans.filter(item => item !== index.toString())
            someProperty = changeVisibility([], findDepsWithDepth(id, index))
        }
        someProperty[id] = {...someProperty[id], ans: ans};
        setResForm(someProperty)
    }

    const handleStructuralRadio = (id, value) => {
        let someProperty = checkItemDependency(id, value)
        someProperty[id] = {...someProperty[id], ans: value.toString()};
        setResForm(someProperty)
    }

    const handleStructuralTextBox = (id, value) => {
        let someProperty = {...resForm}
        someProperty[id] = {...someProperty[id], ans: value};
        setResForm(someProperty)
    }

    const finalAnswers = () => {
        let obj = Object.values(resForm).filter(item => !snippets.isObjectEmpty(item.ans))
        console.log(obj)
    }

    const ComboBoxFunc = (data) => {
        return <ComboBox show={data?.show}
            // className={data?.className ?? ""}
                         comboboxValues={data?.options}
                         key={data?.key ?? data?.title}
                         nonTransparent
                         fullWidth="false"
                         labelText={data?.title}
                         fieldName={data?.title}
                         changeValueHandler={data.handler}
                         selectedItem={data?.selected}
        />
    }

    const widgets = (key, value) => {
        switch (value["data_type"]) {

            case 'radiobutton':
                let selected = value["options"]?.filter(item => item.id?.toString() === value?.ans)?.shift()
                return <div className={styles.radioBoxes}>
                    <RadioButton inputName={`question-${value['id']}`}
                                 options={value["options"]}
                                 selected={selected}
                                 tabIndex={10}
                                 onChange={(event) => handleStructuralRadio(key, event.id)}
                    />
                </div>

            case 'checkbox':
                return <div className={styles.checkBoxes}>
                    {value["options"]?.map((item, index) => {
                        return <CheckBox type="complex"
                                         name={item}
                                         key={`check-${item}`}
                                         labelText={item}
                                         disableMainLabel={true}
                                         handleChangeValue={(e) => handleStructuralCheck(key, index, e.checked)}
                                         checked={value?.ans?.includes(index)}
                        />
                    })}
                </div>

            case 'select':
                // https://github.com/JedWatson/react-select
                // placeholder : https://codesandbox.io/p/sandbox/6x9405rlqk?file=%2Fexample.js
                return <CreatableSelect
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable
                    isSearchable
                    options={value["values"]}
                    defaultValue={value["ans"]}
                    onChange={ans => handleStructuralCombo2(key, ans)}
                    placeholder={value["question"]}
                    theme={(theme) => ({
                        ...theme,
                        // borderRadius: 0,
                        colors: {
                            ...theme.colors,
                            primary25: colors.hover,
                            primary50: colors.active_background,
                            primary: colors.primary,
                            neutral0: "#474747",
                            neutral80: colors.white_b2,
                            neutral50: colors.white_b2,
                        }
                    })
                    }

                />

            case 'input':
            case 'textarea':
                return <>
                    <TextBox show={value['visibility']}
                        // className={{}}
                             key={`textarea-${key}`}
                             type={"textarea"}
                             showLabel={false}
                             name={`${value["question"]}`}
                             placeholder={value["question"]}
                             changeValue={e => handleStructuralTextBox(key, e.target.value)}
                             value={resForm[key]?.ans}
                    />
                </>

            default:
                console.error("what is this kind of data_type ", value["data_type"], "???")
        }
    }

    const item = (key, value) => {
        let idQuestion = `${key} - ${value["question"]}: `
        return <div className={styles.item}>
            <div className={styles.question} key={idQuestion}>
                <T token={idQuestion} key={idQuestion}/>
            </div>
            <div className={styles.answer} key={`${idQuestion}-ans`}>
                {widgets(key, value)}
            </div>
        </div>
    }

    const handleSectionDetails = (sec, resFrm) => {
        let res = resFrm.filter(([, value]) => value.section === sec)
        if (res.length > 0)
            return <>
                {hrFunc(sec)}
                {resFrm.filter(([, value0]) => value0.section === sec).map(([key, value]) => {
                    return item(key, value)
                })
                }
            </>
    }

    const handleSection = (resFrm) => {
        return resSection?.map(item => {
            return handleSectionDetails(item, resFrm)
        })
    }

    const hrFunc = (text) => {
        return <Divider type={"text"} text={<T token={text.toLowerCase()}/>}/>
    }

    const reportDetails = () => {
        let meta = (({details, id, group_id, ...rest}) => rest)(form);
        meta = snippets.notNullObjectValues(meta)

        return <div className={""}>
            {Object.entries(meta)?.map(([key, value]) => {
                return <div className="row p-1" key={key}>
                    <div className="col-3 px-2 text-nowrap">
                        <T token={key}/> :
                    </div>
                    <div className="col text-wrap text-break ">
                        {value}
                    </div>
                </div>
            })}
        </div>
    }


    return (
        <div className={styles.main}>
            <Header page={"structural-report"}/>
            <div className={styles.structural} dir={direction}>
                <div className={styles.chooseReport}>
                    <div className={styles.button}>
                        {ComboBoxFunc(lang)}
                    </div>

                    <div className={styles.button}>
                        {ComboBoxFunc(groups)}
                    </div>

                    <div className={styles.button}>
                        {ComboBoxFunc(structures)}
                    </div>

                    <div className={styles.info} onClick={() => setDetails({...details, show: true})}
                    >
                        <i className={'fal fa-circle fa-circle-info'} title={_.init("structure_report_hovered")}>
                            <Popover show={details.show} title={"structure_report_title"}
                                     closePopover={(e) => setDetails({...details, show: e})}>
                                {reportDetails()}
                            </Popover>
                        </i>
                    </div>
                </div>

                <div className={styles.report}>
                    {handleSection(Object.entries(resForm).filter(([, value0]) => value0['visibility']))}
                </div>

                <Button className={styles.finalButton}
                        size="small"
                        customClasses="margin-2px"
                        buttonText={"show_preview"}
                        mode="warning-new"
                        key={0}
                        onClick={finalAnswers}/>

            </div>
            <Footer/>
        </div>
    )
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    const direction = state.LangReducer.direction;
    return {language, direction};
};

export default connect(mapStateToProps)(StructuralReport);